// extracted by mini-css-extract-plugin
module.exports = {"sidebar-toggle":"style_sidebar-toggle__30Ict"};